import { useState } from 'react'
import { AppliedSortsAndFilters } from './RegistryGiftGiverPage.types'

export const defaultAppliedSortsAndFilters: AppliedSortsAndFilters = {
  filters: { category: 'All' },
  sort: 'category',
}

export const useAppliedSortsAndFilters = () => {
  const [appliedSortsAndFilters, setAppliedSortsAndFilters] =
    useState<AppliedSortsAndFilters>(defaultAppliedSortsAndFilters)

  const handleSortFilterChange = (
    changedPartialSortFilter: Partial<AppliedSortsAndFilters>
  ) => {
    setAppliedSortsAndFilters((prev: AppliedSortsAndFilters) => ({
      ...prev,
      ...changedPartialSortFilter,
    }))
  }

  return { appliedSortsAndFilters, handleSortFilterChange }
}
